import type { Consultant } from '../types/content';

/**
 * Executive search team. Add `bio` and `portraitUrl` to an entry once approved —
 * the profile layout picks them up automatically.
 */
export const consultants: Consultant[] = [
  {
    slug: 'david',
    name: 'David',
    title: 'Executive Search Consultant',
    email: 'david@qorvessaexecutivepartners.com',
  },
  {
    slug: 'ebenezer',
    name: 'Ebenezer',
    title: 'Executive Search Consultant',
    email: 'ebenezer@qorvessaexecutivepartners.com',
  },
  {
    slug: 'mustapha',
    name: 'Mustapha',
    title: 'Executive Search Consultant',
    email: 'mustapha@qorvessaexecutivepartners.com',
  },
];
